webpackJsonp(["core"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy() {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/ajax-submit/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = "[data-ajax-submit]";
var PLUGIN_NAME = "ajaxSubmit";

var elements = document.querySelectorAll(ELEMENT_SELECTOR);

elements.forEach(function (element) {
	__webpack_require__.e/* import() */("ajax-submit").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/ajax-submit/ajax-submit.js")).then(function (module) {
		(0, _lib2.default)(PLUGIN_NAME, module.default);
		(0, _jquery2.default)(element)[PLUGIN_NAME]();
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/alerts/dismiss.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dismiss
 * Alerts
 * @author Oliver Boermans
 */

var log = (0, _debug2.default)("alerts");

//
// Config
// ===========
var ALERT_SELECTOR = "[data-alert]";
var ALERT_BUTTON_SELECTOR = 'button';

var hidePanel = function hidePanel(alertToHide) {
	(0, _jquery2.default)(alertToHide).hide();
	(0, _jquery2.default)('body').removeClass('has-alert');
};

var dismissAlert = function dismissAlert(instance) {
	var element = instance.element,
	    alertApi = instance.alertApi,
	    alertId = instance.alertId;

	_jquery2.default.get(alertApi, {
		id: alertId
	});
	hidePanel(element);
};

function init() {
	var alertElements = (0, _jquery2.default)(ALERT_SELECTOR);
	log(alertElements);
	alertElements.each(function (index, element) {
		var alertApi = element.dataset.alertApi;
		var alertId = element.id;
		var alertButton = (0, _jquery2.default)(element).find(ALERT_BUTTON_SELECTOR);

		if (alertButton.length) {
			alertButton.on('click', dismissAlert.bind(null, { element: element, alertApi: alertApi, alertId: alertId }));
		} else {
			log("No site alert button found.");
		}
	});
};

init();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/alerts/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/alerts/dismiss.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/choose-form/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-choose-form]';
var PLUGIN_NAME = 'chooseForm';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("choose-form").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/choose-form/choose-form.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/cover-selector/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(function () {
	$("[data-cover-selector]").each(function () {
		var element = this;
		__webpack_require__.e/* import() */("cover-selector").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/cover-selector/index.js"));
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/date-field/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = "[data-date-field]";
var PLUGIN_NAME = "dateField";

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("date-field").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/date-field/date-field.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/epi-blocks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/epi-blocks/quote-cta/index--split.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/epi-blocks/quote-cta/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-quote-cta-controller]';
var PLUGIN_NAME = 'quoteCtaController';

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("quote-cta").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/epi-blocks/quote-cta/quote-cta.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/quote-form/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/choose-form/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/product-card/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/cover-selector/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/required-field/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/date-field/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/localize-date/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/site-header/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/modal/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/search/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/epi-blocks/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/alerts/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/wysiwyg/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/scrollbar-width/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/ajax-submit/index--split.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/sync-same-name/index--split.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/localize-date/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = "[data-localize-date]";
var PLUGIN_NAME = "localizeDate";

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("date-field").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/localize-date/localize-date.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modaal is not a spelling error!
// It is the name of the 3rd party modal component we are using
var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-modal]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'modal';

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("component--modal").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/modal/modal.js")).then(function () {
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/product-card/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-product-card]';
var PLUGIN_NAME = 'productCard';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("product-card").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/product-card/product-card.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/quote-form/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-quote-form]';
var PLUGIN_NAME = 'quoteForm';

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		__webpack_require__.e/* import() */("quote-form").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/quote-form/quote-form.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/required-field/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/required-field/required-field.js");

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = "[data-required-field]";
var PLUGIN_NAME = "requiredField";

(0, _jquery2.default)(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
		var element = this;
		new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/required-field/required-field.js")).then(function (module) {
			(0, _lib2.default)(PLUGIN_NAME, module.default);
			(0, _jquery2.default)(element)[PLUGIN_NAME]();
		});
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/required-field/required-field.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("required-field");

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var validators = {
	'at_least_one_checked': function at_least_one_checked(inputs) {
		return inputs.filter(function (input) {
			return input.checked;
		}).length > 0 ? '' : 'check at least one';
	},
	regex: function regex(expression, input) {
		var regex = new RegExp(expression);
		return regex.test(input.value);
	}
};

var RequiredField = function () {
	function RequiredField(element, options) {
		_classCallCheck(this, RequiredField);

		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.isFieldset = this.element.nodeName === 'FIELDSET';

		this.inputSet = [].concat(_toConsumableArray(this.element.querySelectorAll("[name=\"" + this.options.inputSet + "\"]")));

		this.input = this.element.querySelector("[name=\"" + this.options.name + "\"]");

		this.errorElementSelectorScope = this.options.errorSelector[0] === "#" ? document : this.element;

		this.errorElement = this.errorElementSelectorScope.querySelector(this.options.errorSelector);

		this.showErrors = getJSONValue(this.element.dataset.showErrors);

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.init();
		this.watch();

		log("ready", this, this.element);
	}

	_createClass(RequiredField, [{
		key: "init",
		value: function init() {
			this.updateValidity();
			this.validateInput();
		}
	}, {
		key: "watch",
		value: function watch() {
			log("watching");
			this.element.addEventListener("change", this.updateValidity.bind(this));
			this.attributeObserver.observe(this.element, { attributes: true });
			this.input.addEventListener("input", this.updateValidity.bind(this));
			this.input.addEventListener("validate", this.updateValidity.bind(this));
		}
	}, {
		key: "isValid",
		value: function isValid() {
			var elementToValidate = this.isFieldset ? this.element : this.input;
			return elementToValidate.validity.valid;
		}
	}, {
		key: "updateFieldsetValidity",
		value: function updateFieldsetValidity() {
			var validator = validators[this.options.rule];
			if (!this.isFieldset || !validator) {
				return false;
			}

			this.element.setCustomValidity(validator(this.inputSet));
		}
	}, {
		key: "updateErrorMessage",
		value: function updateErrorMessage() {
			this.errorElement.hidden = this.isValid();
		}
	}, {
		key: "updateValidity",
		value: function updateValidity() {
			this.updateFieldsetValidity();
			this.validateInput();

			if (this.showErrors) {
				this.updateErrorMessage();
			}
		}
	}, {
		key: "onAttributeChange",
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === "attributes" && mutation.attributeName === this.options.componentErrorAttribute;
			}.bind(this)).forEach(this.onShowErrorsChange.bind(this));
		}
	}, {
		key: "onShowErrorsChange",
		value: function onShowErrorsChange(mutation) {
			this.showErrors = getJSONValue(this.element.dataset.showErrors);
			this.updateErrorMessage();
		}
	}, {
		key: "validateInput",
		value: function validateInput() {
			var _this = this;

			if (!this.input) {
				return false;
			}

			var tests = [getRegexValidator(validators, this.input.dataset)].filter(truthy);

			// Validation may have been disabled if this field was hidden
			if (this.element.dataset.validateField === "false") {
				this.element.setCustomValidity("");
				return false;
			}

			if (this.input.value !== "" && tests.length) {
				var results = tests.map(function (validator) {
					return validator.test(_this.input) ? "" : validator.message;
				});

				var errors = results.filter(function (result) {
					return result !== "";
				});

				this.input.setCustomValidity(errors.length ? errors[0] : "");
			} else {
				this.input.setCustomValidity("");
			}
		}
	}]);

	return RequiredField;
}();

function getRegexValidator(validators, data) {
	//const message = data.valRegexMessage || data.valRegex;
	var message = 'Invalid';

	if (!data) {
		return false;
	}

	if (data.valRegexPatternName && validators[data.valRegexPatternName]) {
		return { test: validators[data.valRegexPatternName], message: message };
	}
	if (data.valRegexPattern) {
		return {
			test: validators.regex.bind(null, data.valRegexPattern),
			message: message
		};
	}
	return false;
}

function truthy(value) {
	return value;
}

RequiredField.DEFAULTS = {
	componentErrorAttribute: "data-show-errors"
};

exports.default = RequiredField;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/scrollbar-width/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/scrollbar-width/scrollbar-width.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/scrollbar-width/scrollbar-width.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function calculateScrollbarWidth() {
	document.documentElement.style.setProperty("--root-scrollbar-width", window.innerWidth - document.documentElement.clientWidth + "px");
}
window.addEventListener("resize", calculateScrollbarWidth, false);

calculateScrollbarWidth();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/search/global-search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/search/global-search/search-form-collapsible.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/search/global-search/search-form-collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-search-form-collapsible]';
var PLUGIN_NAME = 'searchFormCollapsible';

var log = (0, _debug2.default)('site-header/header-controller:search');

var SearchFormCollapsible = function () {
	function SearchFormCollapsible(element, options) {
		_classCallCheck(this, SearchFormCollapsible);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.enabled = false;

		this.formElements = this.selectors.selectTarget(this.options.elementsSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(SearchFormCollapsible, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.$element.on('togglesearch', this.toggle.bind(this));
			this.$element.on('disablesearch', this.disable.bind(this));
		}
	}, {
		key: 'enable',
		value: function enable() {
			this.formElements.removeAttr('disabled');
			this.enabled = true;
			this.formElements[0].focus();
			log('enable');
		}
	}, {
		key: 'disable',
		value: function disable() {
			this.formElements.attr('disabled', 'disabled');
			this.enabled = false;
			log('disable');
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			var handler = this.enabled ? this.disable.bind(this) : this.enable.bind(this);
			log('toggle');
			handler();
		}
	}]);

	return SearchFormCollapsible;
}();

SearchFormCollapsible.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, SearchFormCollapsible);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/search/global-search/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/site-header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/site-header/navigation--obscurable.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/site-header/site-header-controller.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/site-header/navigation--obscurable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Obscurable Navigation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @original-idea Kate York
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @original-idea Oliver Boermans
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author Zenobius Jiricek
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * see ./header.scss
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

//
// Utilities


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLUGIN_NAME = "ObscurableNavigation";
var ELEMENT_SELECTOR = "[data-navigation-obscurable]";
var log = (0, _debug2.default)('core/components/site-header/navigation--obscurable');

var ObscurableNavigationPlugin = function () {
  function ObscurableNavigationPlugin(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ObscurableNavigationPlugin);

    this.element = element;
    this.$element = (0, _jquery2.default)(element);
    this.options = options;
    this.options.tolerancePx = parseInt(this.options.tolerancePx);

    log('created', { element: element, options: this.options });
    this.components = {
      obscuredItemContainer: (0, _selectors.selectTarget)(this.options.obscuredItemContainerSelector, this.$element),
      visibleItemContainer: (0, _selectors.selectTarget)(this.options.visibleItemContainerSelector, this.$element),
      obscuredItemContainerToggle: (0, _selectors.selectTarget)(this.options.obscuredItemContainerToggleSelector, this.$element)
    };

    this.watch();
  }

  _createClass(ObscurableNavigationPlugin, [{
    key: 'watch',
    value: function watch() {
      var _this = this;

      log('watch');
      this.currentTestId = 0;
      (0, _jquery2.default)(window).resize(function () {
        _this.components.visibleItemContainer.addClass('testing');
      });
      (0, _jquery2.default)(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs, true));
      (0, _jquery2.default)(window).resize(this.fn.debounce(this.test.bind(this), this.options.testTimeoutMs));
      setTimeout(this.test.bind(this), this.options.testTimeoutMs);
    }
  }, {
    key: 'test',
    value: function test() {
      log('test');
      this.unObscureItems();
      this.testItems();
    }
  }, {
    key: 'isItemObscured',
    value: function isItemObscured(element) {
      log('isItemObscured', element);
      var $testElement = (0, _jquery2.default)(element);
      var width = $testElement.outerWidth(true);
      var rightEdgePosition = width + this.options.tolerancePx + this.accumulatedWidth;
      var result = rightEdgePosition > this.actualContainerWidth;
      log('isItemObscured', rightEdgePosition, this.actualContainerWidth, result);
      this.accumulatedWidth += width;
      return result;
    }
  }, {
    key: 'unObscureItems',
    value: function unObscureItems() {
      var _this2 = this;

      log('unObscureItems');
      // Put everything back in main nav
      // to prepare for testing if they in fact fit.
      (0, _selectors.selectTarget)(this.options.intersectingItemSelector, this.components.obscuredItemContainer).removeClass(this.options.obscuredItemClasses).addClass(this.options.visibleItemClasses).each(function (index, element) {
        _this2.components.visibleItemContainer.append((0, _jquery2.default)(element).detach());
      });
    }
  }, {
    key: 'moveItem',
    value: function moveItem(element) {
      log('moveItem', element);
      var $element = (0, _jquery2.default)(element).detach();

      $element.addClass(this.options.obscuredItemClasses).removeClass(this.options.visibleItemClasses);

      this.components.obscuredItemContainer.append($element);

      $element.show();
    }
  }, {
    key: 'testItems',
    value: function testItems(items) {
      var _this3 = this;

      log('testItems');
      var toggleWidth = this.components.obscuredItemContainerToggle.innerWidth();
      this.components.obscuredItemContainerToggle.detach();

      // Move the items that don't fit back to mobile nav
      this.components.obscuredItemContainerToggle.show();
      var $items = (0, _selectors.selectTarget)(this.options.intersectingItemSelector, this.components.visibleItemContainer);
      log('testItems.items', $items);

      this.actualContainerWidth = this.components.visibleItemContainer.innerWidth();
      // build a list of items that don't fit
      this.accumulatedWidth = 0;
      var obscuredItems = $items.filter(function (index, element) {
        return _this3.isItemObscured(element);
      });
      log('testItems.obscuredItems', obscuredItems);

      // if at least one item doesn't fit
      if (!this.components.visibleItemContainer.is(':visible')) {
        $items.each(function (index, element) {
          return _this3.moveItem(element);
        });
      } else if (obscuredItems.length > 0) {
        // reduce width of container
        this.actualContainerWidth = this.actualContainerWidth - toggleWidth;
        log('testItems.atLeatOneObscured', this.actualContainerWidth);

        this.accumulatedWidth = 0;
        obscuredItems = $items
        // re-test visible items based on new container width
        .filter(function (index, element) {
          return _this3.isItemObscured(element);
        })
        // then move them
        .each(function (index, element) {
          return _this3.moveItem(element);
        });
      }

      if (obscuredItems.length > 0 || obscuredItems.length == $items.length) {
        this.components.visibleItemContainer.append(this.components.obscuredItemContainerToggle);
      }

      if (!this.components.obscuredItemContainer.children().length > 0) {
        this.components.obscuredItemContainerToggle.hide();
      }

      this.components.visibleItemContainer.removeClass('testing');
    }
  }]);

  return ObscurableNavigationPlugin;
}();

ObscurableNavigationPlugin.DEFAULTS = {
  tolerancePx: 40,
  testTimeoutMs: 150,
  reflowOnResize: true,
  visibleItemClasses: 'navigation__item--unobscured',
  obscuredItemClasses: 'navigation__item--obscured',
  visibleItemContainerSelector: '(children) [data-navigation--visible-items]',
  intersectingItemSelector: '(children) [data-navigation--intersecting-item]',
  obscuredItemContainerSelector: '(children) [data-navigation--obscured-items]',
  obscuredItemContainerToggleSelector: '(children) [data-navigation--obscured-items-toggle]'
};

(0, _lib2.default)(PLUGIN_NAME, ObscurableNavigationPlugin);

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/site-header/site-header-controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ELEMENT_SELECTOR = '[data-header-controller]';
var PLUGIN_NAME = 'headerController';

var log = (0, _debug2.default)('site-header/header-controller:header');

var HeaderController = function () {
	function HeaderController(element, options) {
		_classCallCheck(this, HeaderController);

		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.isSearchCollapsible = !!this.options.searchComponentSelector;

		this.searchComponent = this.isSearchCollapsible && this.selectors.selectTarget(this.options.searchComponentSelector, this.$element);

		this.phoneComponent = this.selectors.selectTarget(this.options.phoneComponentSelector, this.$element);

		this.watch();

		log('ready', this, this.$target);
	}

	_createClass(HeaderController, [{
		key: 'watch',
		value: function watch() {
			log('watching');

			this.$element.on('concealsearch', this.tryConcealSearch.bind(this));
			this.$element.on('closephone', this.closePhoneComponent.bind(this));
		}
	}, {
		key: 'closePhoneComponent',
		value: function closePhoneComponent() {
			if (this.phoneComponent.length) {
				this.phoneComponent[0].dataset.collapsibleOpen = false;
			}
		}
	}, {
		key: 'tryConcealSearch',
		value: function tryConcealSearch() {
			log('attempting to disable search');
			if (this.isSearchCollapsible) {
				this.searchComponent.trigger('disablesearch');
			} else {
				log('Search is not collapsible');
			}
		}
	}]);

	return HeaderController;
}();

HeaderController.DEFAULTS = {};

(0, _lib2.default)(PLUGIN_NAME, HeaderController);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/sync-same-name/index--split.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = "[data-sync-same-name]";
var PLUGIN_NAME = "syncSameName";

var elements = document.querySelectorAll(ELEMENT_SELECTOR);

elements.forEach(function (element) {
	__webpack_require__.e/* import() */("sync-same-name").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/sync-same-name/sync-same-name.js")).then(function (module) {
		(0, _lib2.default)(PLUGIN_NAME, module.default);
		(0, _jquery2.default)(element)[PLUGIN_NAME]();
	});
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/wysiwyg/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/wysiwyg/table-cell-icons.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/wysiwyg/table-cell-icons.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Table Cell Icons
 * Replaces table cell content based on cell content.
 * @author Rhys Lloyd
 */

var log = (0, _debug2.default)('core/components/wysiwyg/table-cell-icons');

// Constants
var TABLE_DATA_ATTRIBUTE = 'data-table-icons';
var TABLE_IGNORE = 'ignore';
var ICON_KEYWORDS = ['yes', 'restricted', 'no'];
var ICON_BRACKET_OPEN = '[';
var ICON_BRACKET_CLOSE = ']';
var KEYWORD_ICON = {
	'yes': 'covered',
	'restricted': 'restricted',
	'no': 'excluded'
};

function getIconClassString(keyword) {
	return 'icon--' + keyword;
}

function keywordFormatter(keyword) {
	return '' + ICON_BRACKET_OPEN + keyword + ICON_BRACKET_CLOSE;
}

//noinspection SpellCheckingInspection
function keywordUnformatter(keyword) {
	return keyword.substring(ICON_BRACKET_OPEN.length, keyword.length - ICON_BRACKET_CLOSE.length);
}

function iconLookup(keyword) {
	return KEYWORD_ICON[keyword] || keyword;
}

/**
 * Run plugin
 */
function exec() {
	log('Running...');

	// Find tables
	var $tables = (0, _jquery2.default)('table').filter(':not([' + TABLE_DATA_ATTRIBUTE + '="' + TABLE_IGNORE + '"])');

	if (!$tables.length) {
		log('No tables to parse.');
		return;
	}

	// Add data attribute - in progress value
	$tables.attr(TABLE_DATA_ATTRIBUTE, 'in-progress');
	log('Parsing tables', $tables);

	// Cell icon template
	var $labelTemplate = (0, _jquery2.default)('<span>').addClass('icon__label u-visually-hidden'),
	    $iconTemplate = (0, _jquery2.default)('<i>').addClass('icon');

	// Match replacer - nested function for closure access to $iconTemplate
	function keywordReplacer(match) {
		var keyword = keywordUnformatter(match),
		    iconName = iconLookup(keyword),
		    $label = $labelTemplate.clone().text(keyword);

		return $iconTemplate.clone().addClass(getIconClassString(iconName)).addClass('keyword-icon keyword-icon--' + keyword).append($label).prop('outerHTML');
	}

	// Loop through all TD cells
	$tables.find('td').each(function () {
		var $this = (0, _jquery2.default)(this);

		// For each keyword, loop through cell contents and replace
		// keyword with icon template
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = ICON_KEYWORDS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var keyword = _step.value;

				var original = $this.html(),
				    updated = original.replace(keywordFormatter(keyword), keywordReplacer);

				if (original !== updated) {
					log('Replacing cell contents:\nOriginal:', original, '\nUpdated:', updated);
					$this.html(updated);
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	});

	// Set data attribute to indicate done
	$tables.attr(TABLE_DATA_ATTRIBUTE, true);
}

exec();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/index.js");

__webpack_require__("/tool/project/client/src/core/vendor/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('fusion-core');

// See polyfills bundle - this should not be needed here too
// import "./polyfills";


(0, _jquery2.default)(function () {
	log('ready');
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__collapsible/plugin--bundled.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__radio-selection/plugin--bundled.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__toggle-element-classes/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__remove-element-classes/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__add-element-classes/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus-within/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__form-loading/plugin--bundled.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__emit-on-dirty/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__trigger-event/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__add-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-add-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'AddElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--add-element-classes").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__add-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__collapsible/collapsible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _debug2.default)("collapsible");

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

var Collapsible = function () {
	function Collapsible(element, options) {
		_classCallCheck(this, Collapsible);

		this.element = element;
		this.options = options;

		var scopes = {
			document: document,
			element: this.element
		};

		//	Look for the content element within this element or elsewhere
		var contentSelectorIsId = this.options.contentSelector && this.options.contentSelector[0] === "#";

		if (contentSelectorIsId) {
			this.contentSelectorScope = scopes["document"];
		} else {
			this.contentSelectorScope = scopes[this.options.contentSelectorScope] ? scopes[this.options.contentSelectorScope] : scopes["element"];
		}

		// if no button is specified perhaps this is the button
		this.button = this.options.buttonSelector ? this.element.querySelector(this.options.buttonSelector) : this.element;

		// Content is optional
		//	we may be toggling with CSS based on aria-expanded button attr
		this.content = this.options.contentSelector && this.contentSelectorScope.querySelector(this.options.contentSelector);
		this.collapseWith = this.options.collapsedClass ? "class" : "hidden";
		this.collapsedClass = this.options.collapsedClass;

		this.toggleMethod = this.collapseWith === "class" ? this.toggleWithClass : this.toggleWithHidden;

		this.attributeObserver = new MutationObserver(this.onAttributeChange.bind(this));

		this.bindDocumentEvents = this.options.closeWithDocumentClick ? this.bindDocumentClick : function () {};

		this.unbindDocumentEvents = this.options.closeWithDocumentClick ? this.unbindDocumentClick : function () {};

		this.init();
		this.watch();
	}

	_createClass(Collapsible, [{
		key: "init",
		value: function init() {
			// component enabled - show the button
			this.button.hidden = false;

			// Determine initial collapse state
			//	if set open option determines init state
			var doCollapse = this.options.open !== undefined ? !this.options.open : true;

			this.toggleMethod(doCollapse);
			this.isCollapsed = doCollapse;
		}
	}, {
		key: "watch",
		value: function watch() {
			this.button.addEventListener("click", this.toggle.bind(this));
			this.attributeObserver.observe(this.element, { attributes: true });
		}
	}, {
		key: "toggleWithHidden",
		value: function toggleWithHidden(doCollapse) {
			this.button.setAttribute("aria-expanded", !doCollapse);

			if (!this.content) {
				return false;
			}
			this.content.hidden = doCollapse;
		}
	}, {
		key: "toggleWithClass",
		value: function toggleWithClass(doCollapse) {
			this.button.setAttribute("aria-expanded", !doCollapse);

			if (!this.content) {
				return false;
			}
			if (doCollapse) {
				this.content.classList.add(this.collapsedClass);
			} else {
				this.content.classList.remove(this.collapsedClass);
			}
		}

		// button click handler

	}, {
		key: "toggle",
		value: function toggle() {
			if (!this.options.selfClosing && !this.isCollapsed) {
				return false;
			}

			var handler = this.isCollapsed ? this.open.bind(this) : this.close.bind(this);
			handler();
		}
	}, {
		key: "open",
		value: function open() {
			this.toggleMethod(false);
			this.isCollapsed = false;
			this.element.dataset.collapsibleOpen = true;
			this.bindDocumentEvents();
		}
	}, {
		key: "close",
		value: function close() {
			this.toggleMethod(true);
			this.isCollapsed = true;
			this.element.dataset.collapsibleOpen = false;
			this.unbindDocumentEvents();
		}
	}, {
		key: "bindDocumentClick",
		value: function bindDocumentClick() {
			document.addEventListener("click", this.onDocumentClick.bind(this));
		}
	}, {
		key: "unbindDocumentClick",
		value: function unbindDocumentClick() {
			document.removeEventListener("click", this.onDocumentClick);
		}
	}, {
		key: "onDocumentClick",
		value: function onDocumentClick(event) {
			var clickTarget = event.target;

			// clicked this.button
			if (clickTarget === this.button || this.button.contains(clickTarget)) {
				log("clicked button");
				return false;
			}

			// clicked this.content
			if (this.content && (clickTarget === this.content || this.content.contains(clickTarget))) {
				log("clicked content or inside it");
				return false;
			}

			this.close();
		}
	}, {
		key: "onAttributeChange",
		value: function onAttributeChange(mutationList, observer) {
			mutationList.filter(function (mutation) {
				return mutation.type === "attributes" && mutation.attributeName.startsWith("data-collapsible-open");
			}).forEach(this.onOpenChanged.bind(this));
		}
	}, {
		key: "onOpenChanged",
		value: function onOpenChanged(mutation) {
			var doCollapse = !getJSONValue(this.element.dataset.collapsibleOpen);
			if (this.isCollapsed !== doCollapse) {
				this.toggleMethod(doCollapse);
				this.isCollapsed = doCollapse;
			}
		}
	}]);

	return Collapsible;
}();

Collapsible.DEFAULTS = {
	selfClosing: true
};

exports.default = Collapsible;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__collapsible/plugin--bundled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _collapsible = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__collapsible/collapsible.js");

var _collapsible2 = _interopRequireDefault(_collapsible);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-collapsible]';
var PLUGIN_NAME = 'Collapsible';

(0, _lib2.default)(PLUGIN_NAME, _collapsible2.default);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__emit-on-dirty/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-emit-on-dirty]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'EmitOnDirty';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--emit-on-dirty").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__emit-on-dirty/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus-within/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-focus-within]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'FocusWithin';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--focus-within").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus-within/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-focus-element]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'FocusElement';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--focus-element").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__focus/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__form-loading/form-loading.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FormLoading = function () {
	function FormLoading(element, options) {
		_classCallCheck(this, FormLoading);

		this.element = element;
		this.options = options;
		this.watch();
	}

	_createClass(FormLoading, [{
		key: "watch",
		value: function watch() {
			this.element.addEventListener("submit", this.applyLoadingState.bind(this));
		}
	}, {
		key: "applyLoadingState",
		value: function applyLoadingState() {
			this.element.dataset[this.options.dataKey] = this.options.dataValue;
			var submitButton = this.element.querySelector("button[type=submit]");
			if (submitButton != null) {
				submitButton.setAttribute("aria-label", this.options.dataValue);
			}
		}
	}]);

	return FormLoading;
}();

FormLoading.DEFAULTS = {
	dataKey: 'state',
	dataValue: 'loading'
};
exports.default = FormLoading;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__form-loading/plugin--bundled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _formLoading = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__form-loading/form-loading.js");

var _formLoading2 = _interopRequireDefault(_formLoading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-form-loading]';
var PLUGIN_NAME = 'FormLoading';

(0, _lib2.default)(PLUGIN_NAME, _formLoading2.default);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__radio-selection/plugin--bundled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _lib = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js");

var _lib2 = _interopRequireDefault(_lib);

var _radioSelection = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__radio-selection/radio-selection.js");

var _radioSelection2 = _interopRequireDefault(_radioSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = '[data-radio-selection]';
var PLUGIN_NAME = 'RadioSelection';

(0, _lib2.default)(PLUGIN_NAME, _radioSelection2.default);

(0, _jquery2.default)(document).ready(function () {
	(0, _jquery2.default)(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__radio-selection/radio-selection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// IE Needs element.closest polyfill - see polyfills
// https://gomakethings.com/a-native-vanilla-javascript-way-to-get-the-closest-matching-parent-element/


var RadioSelection = function () {
	function RadioSelection(element, options) {
		_classCallCheck(this, RadioSelection);

		this.element = element;
		this.options = options;

		// scoped to parent form or other form if specified
		this.form = this.options.formSelector ? this.element.querySelector(this.options.formSelector) : this.element.closest('form');

		this.inputs = this.form.elements[this.options.name];

		if (!this.form || !this.options.name || !this.inputs) {
			return false;
		}

		this.init();
		this.watch();
	}

	_createClass(RadioSelection, [{
		key: 'init',
		value: function init() {
			this.updateValue();
		}
	}, {
		key: 'watch',
		value: function watch() {
			var _this = this;

			[].concat(_toConsumableArray(this.inputs)).forEach(function (input) {
				input.addEventListener('change', _this.updateValue.bind(_this));
			});
		}
	}, {
		key: 'updateValue',
		value: function updateValue() {
			var value = this.inputs.value;
			var checkedInput = this.form.querySelector('[name="' + this.options.name + '"][value="' + value + '"]');
			var label = this.form.querySelector('label[for="' + checkedInput.id + '"]');

			if (!label) {
				console.warn('Label missing for radio input', checkedInput);
			}
			this.element.textContent = label.textContent;
		}
	}]);

	return RadioSelection;
}();

RadioSelection.DEFAULTS = {};

exports.default = RadioSelection;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__remove-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-remove-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'RemoveElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--remove-element-classes").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__remove-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__toggle-element-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-toggle-element-classes]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'ToggleElementClasses';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--toggle-element-classes").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__toggle-element-classes/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__trigger-event/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_NAME = exports.ELEMENT_SELECTOR = undefined;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ELEMENT_SELECTOR = exports.ELEMENT_SELECTOR = '[data-trigger-event]';
var PLUGIN_NAME = exports.PLUGIN_NAME = 'triggerEvent';

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(ELEMENT_SELECTOR).each(function () {
    var element = this;
    __webpack_require__.e/* import() */("plugin--trigger-event").then(__webpack_require__.bind(null, "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/jquery__trigger-event/plugin.js")).then(function () {
      (0, _jquery2.default)(element)[PLUGIN_NAME]();
    });
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/fn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                              jQuery plugin
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              import debug from 'debug';
                                                                                                                                                                                                                                                                              import plugin from '@core/plugins/lib';
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              const ELEMENT_SELECTOR = '[data-my-plugin]';
                                                                                                                                                                                                                                                                              const PLUGIN_NAME = 'MyPlugin';
                                                                                                                                                                                                                                                                              const MODULE_NAME = 'plugins/my-plugin';
                                                                                                                                                                                                                                                                              const log = debug(MODULE_NAME);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              class PluginKlass {
                                                                                                                                                                                                                                                                                  constructor(element, options) {
                                                                                                                                                                                                                                                                                    log('new instance', element, options);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.element = element;
                                                                                                                                                                                                                                                                                    this.options = options;
                                                                                                                                                                                                                                                                                    this.$element = $(element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    log('ready', this.$element);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                                    this.init();
                                                                                                                                                                                                                                                                                  }
                                                                                                                                                                                                                                                                              }
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              PluginKlass.DEFAULTS = {
                                                                                                                                                                                                                                                                                someCamelCasedProperty: `${PLUGIN_NAME}:something`,
                                                                                                                                                                                                                                                                              };
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              plugin(PLUGIN_NAME, PluginKlass);
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              $(document).ready(() => {
                                                                                                                                                                                                                                                                                $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
                                                                                                                                                                                                                                                                              });
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Then using it in html:
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              <div class="something-else"
                                                                                                                                                                                                                                                                                   data-my-plugin
                                                                                                                                                                                                                                                                                   data-my-plugin--some-camel-cased-property="a-string:something-else"></div>
                                                                                                                                                                                                                                                                              ```
                                                                                                                                                                                                                                                                              
                                                                                                                                                                                                                                                                              Styelguide Core.Global.Javascript.JqueryPlugin
                                                                                                                                                                                                                                                                              */

// import * as events from './events';

exports.default = plugin;
exports.jquery = jquery;
exports.defaults = defaults;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _fn = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/fn.js");

var fn = _interopRequireWildcard(_fn);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js");

var strings = _interopRequireWildcard(_strings);

var _objects = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/objects.js");

var objects = _interopRequireWildcard(_objects);

var _selectors = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js");

var selectors = _interopRequireWildcard(_selectors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib');

function plugin(pluginName, klass) {
  var shortHand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var formattedPluginName = (0, _strings.toCamelCase)(pluginName);
  var dataName = '__' + formattedPluginName;
  var old = _jquery2.default.fn[formattedPluginName];
  var ZERO = 0;

  klass.$bus = {
    subscribe: function subscribe(event, fn) {
      (0, _jquery2.default)(this).bind(event, fn);
    },
    publish: function publish(event, data) {
      (0, _jquery2.default)(this).trigger(event, [data]);
    }
  };

  klass.$util = {
    fn: fn,
    objects: objects,
    strings: strings,
    selectors: selectors
  };

  klass.prototype.selectors = selectors;
  klass.prototype.strings = strings;
  klass.prototype.objects = objects;
  klass.prototype.fn = fn;
  klass.prototype.inViewport = function (elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  };

  _jquery2.default.fn[pluginName] = function PluginFactory(option) {
    return this.each(function PluginInstanceFactory() {
      var $this = (0, _jquery2.default)(this);
      var data = $this.data();
      var overrides = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;
      var elementOptions = Object.keys(data).filter(function (key) {
        return (0, _strings.toCamelCase)(key).indexOf(formattedPluginName) >= ZERO;
      }).reduce(function (result, path) {
        var data = path && $this.data(path);
        var key = (0, _strings.toCamelCase)(path.replace(new RegExp(formattedPluginName + '-?'), ''));
        log(path, key, $this.data(path));

        if (key && data !== undefined) {
          result[key] = data;
        }
        return result;
      }, {});
      log(pluginName, { elementOptions: elementOptions });
      var instance = $this.data(dataName);
      var options = _jquery2.default.extend({}, klass.DEFAULTS, elementOptions, overrides);

      // store reference to instance
      if (!instance) {
        instance = new klass(this, options);
        instance.$utils = klass.$util;
        $this.data(dataName, instance);
        $this.addClass('u-' + pluginName);
      }

      // execute instance method
      if (typeof option === 'string') {
        instance[option]();
      }
    });
  };

  // - Short hand
  if (shortHand) {
    _jquery2.default[formattedPluginName] = function (options) {
      return (0, _jquery2.default)({})[formattedPluginName](options);
    };
  }

  // - No conflict
  // $.fn[formattedPluginName].noConflict = function noConflict () {
  //   $.fn[formattedPluginName] = old;
  // };
}

function jquery(name) {
  return function decorate(target) {
    plugin(name, target);
  };
}

function defaults(options) {
  return function decorate(target) {
    target.DEFAULTS = options;
  };
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/objects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementAttrtibutesToObject = elementAttrtibutesToObject;
exports.objectPath = objectPath;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _strings = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'app.core/lib/objects';
var log = (0, _debug2.default)(MODULE_NAME);

var ZERO = 0;

/**
 * Convert an elements attributes to an object, optionally filtering based on some predicate.
 * @param  {DOMElement}   element  [description]
 * @param  {Function} filterFn filtering function. return false to omit attribute.
 * @param  {Function} transformFn transform attribute name function. returns camelCase by default
 * @return {[type]}            [description]
 */
function elementAttrtibutesToObject(element) {
  var filterFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (name) {
    return (0, _strings.toCamelCase)(name);
  };

  var output = {};
  var attrs = Array.from($(element).get(ZERO).attributes);

  if (!attrs) {
    return output;
  }

  log('converting element attributes to object', attrs);

  return attrs.reduce(function (result, attribute) {
    if (filterFn(attribute)) {
      var name = transformFn(attribute.name);
      var value = attribute.value;

      if (value === 'false' || value === 'true') {
        value = Boolean(value);
      }
      result[name] = attribute.value;
    }

    return result;
  }, output);
}

/**
 * Object.prop()
 *
 * Allows dot-notation access to object properties for both getting and setting.
 *
 * @param {Object} obj    The object we're getting from or setting
 * @param {string} prop   The dot-notated string defining the property location
 * @param {mixed}  val    For setting only; the value to set
 */

function objectPath(obj, path, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { delimiter: '.' };

  var props = path.split(options.delimiter);
  var final = props.pop();
  var part = void 0;

  for (var index = 0; index < props.length; index++) {
    part = props[index];
    if (typeof obj[part] === 'undefined') {
      // If we're setting
      if (typeof val !== 'undefined' && index != props.length) {
        // If we're not at the end of the props, keep adding new empty objects
        obj[part] = {};
      } else {
        return undefined;
      }
    }
    obj = obj[part];
  }
  return typeof val !== "undefined" ? obj[final] = val : obj[final];
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECTOR_PATTERNS = undefined;
exports.selectorPattern = selectorPattern;
exports.selectTarget = selectTarget;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/plugins/lib/selectors');

function selectorPattern() {
  for (var _len = arguments.length, directives = Array(_len), _key = 0; _key < _len; _key++) {
    directives[_key] = arguments[_key];
  }

  return new RegExp('\\((' + directives.join('|') + ')(.*)\\)\\s?(.*)');
}

var SELECTOR_PATTERNS = exports.SELECTOR_PATTERNS = {

  // .find
  "children": selectorPattern('children'),

  // .closest
  "parent": selectorPattern('parent'),
  "from": selectorPattern('from'),
  "parents": selectorPattern('parents'),
  "siblings": selectorPattern('siblings'),
  "here": selectorPattern('here'),
  "self": selectorPattern('self')
};

function selectTarget(selector, $element) {
  var $target = void 0;

  var isClosestAncestoral = selector.match(SELECTOR_PATTERNS.parent);
  var isAllAncestoral = selector.match(SELECTOR_PATTERNS.parents);
  var isRetargeted = selector.match(SELECTOR_PATTERNS.from);
  var isAllDescendants = selector.match(SELECTOR_PATTERNS.children);
  var isGenerational = selector.match(SELECTOR_PATTERNS.here);
  var isSiblings = selector.match(SELECTOR_PATTERNS.siblings);
  var isSelfish = selector.match(SELECTOR_PATTERNS.self);

  // special retargeting root
  if (isRetargeted) {
    log('isRetargeted', isRetargeted[2], isRetargeted[3]);
    var $newElement = selectTarget(isRetargeted[2], $element);
    var newSelector = '(children) ' + isRetargeted[3];
    log('isRetargeted.newElement', $newElement);
    log('isRetargeted.newSelector', newSelector);
    $target = selectTarget(newSelector, $newElement);
    log('isRetargeted.target', $target);
  }

  // target is all ancestors
  else if (isAllAncestoral) {
      log('isAllAncestoral', isAllAncestoral);
      $target = $element.parents(isAllAncestoral[isAllAncestoral.length - 1]);
    }
    // target is closest ancestor
    else if (isClosestAncestoral) {
        log('isClosestAncestoral', isClosestAncestoral);
        $target = $element.closest(isClosestAncestoral[isClosestAncestoral.length - 1]);
      }
      // target is somewhere under current parent
      else if (isGenerational) {
          log('isGenerational', isGenerational);
          $target = $element.parent().find(isGenerational[isGenerational.length - 1]);
        }
        // target is only under self
        else if (isAllDescendants) {
            log('isAllDescendants', isAllDescendants);
            $target = $element.find(isAllDescendants[isAllDescendants.length - 1]);
          }
          // target is somewhere in siblings only
          else if (isSiblings) {
              log('isSiblings', isSiblings);
              $target = $element.siblings(isSiblings[isSiblings.length - 1]);
            }
            // target is source
            else if (!selector || isSelfish) {
                log('isSelfish', isSelfish);
                var selector = isSelfish[isSelfish.length - 1] || '*';
                $target = $element.filter(selector);
              }
              // target could be anywhere
              else {
                  log('global', selector);
                  $target = (0, _jquery2.default)(selector);
                }
  return $target;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/plugins/lib/strings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toCamelCase = toCamelCase;
exports.tmpl = tmpl;
exports.$tmpl = $tmpl;
exports.mustache = mustache;
exports.booleanify = booleanify;

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('core/jquery_plugin/strings');

function preserveCamelCase(str) {
  var isLastCharLower = false;
  var isLastCharUpper = false;
  var isLastLastCharUpper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (isLastCharLower && /[a-zA-Z]/.test(c) && c.toUpperCase() === c) {
      str = str.substr(0, i) + '-' + str.substr(i);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      i++;
    } else if (isLastCharUpper && isLastLastCharUpper && /[a-zA-Z]/.test(c) && c.toLowerCase() === c) {
      str = str.substr(0, i - 1) + '-' + str.substr(i - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = c.toLowerCase() === c;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = c.toUpperCase() === c;
    }
  }

  return str;
}

function toCamelCase(str) {
  if (arguments.length > 1) {
    str = Array.from(arguments).map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x.length;
    }).join('-');
  } else {
    str = str.trim();
  }

  if (str.length === 0) {
    return '';
  }

  if (str.length === 1) {
    return str.toLowerCase();
  }

  if (/^[a-z0-9]+$/.test(str)) {
    return str;
  }

  var hasUpperCase = str !== str.toLowerCase();

  if (hasUpperCase) {
    str = preserveCamelCase(str);
  }

  return str.replace(/^[_.\- ]+/, '').toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (m, p1) {
    return p1.toUpperCase();
  });
};

function tmpl(str, context) {
  var result = str;

  if (result) {

    Object.keys(context).forEach(function (item) {
      result = result.replace('{{' + item + '}}', context[item]);
    });
  }

  return result;
}

function $tmpl(element, context) {
  var $target = (0, _jquery2.default)(element);
  var templateString = $target.attr('data-text-template');
  var result = tmpl(templateString, context);

  $target.text(result);
}

/**
 * https://github.com/aishikaty/tiny-mustache
 * https://mustache.github.io/
 * @param  {String} template [description]
 * @param  {[type]} self     [description]
 * @param  {[type]} parent   [description]
 * @param  {[type]} invert   [description]
 * @return {[type]}          [description]
 */
function mustache(template, self, parent, invert) {
  var render = mustache;
  var output = "";
  var i;

  log('mustache', { template: template, self: self, parent: parent, invert: invert });

  function get(ctx, path) {
    path = path.pop ? path : path.split(".");
    ctx = ctx[path.shift()] || "";
    return 0 in path ? get(ctx, path) : ctx;
  }

  self = Array.isArray(self) ? self : self ? [self] : [];
  self = invert ? 0 in self ? [] : [1] : self;

  for (i = 0; i < self.length; i++) {
    var childCode = '';
    var depth = 0;
    var inverted;
    var ctx = _typeof(self[i]) == "object" ? self[i] : {};
    ctx = Object.assign({}, parent, ctx);
    ctx[""] = { "": self[i] };

    template.replace(/([\s\S]*?)({{((\/)|(\^)|#)(.*?)}}|$)/g, function (match, code, y, z, close, invert, name) {

      if (!depth) {
        output += code.replace(/{{{(.*?)}}}|{{(!?)(&?)(>?)(.*?)}}/g, function (match, raw, comment, isRaw, partial, name) {
          return raw ? get(ctx, raw) : isRaw ? get(ctx, name) : partial ? render(get(ctx, name), ctx) : !comment ? new Option(get(ctx, name)).innerHTML : "";
        });
        inverted = invert;
      } else {
        childCode += depth && !close || depth > 1 ? match : code;
      }

      if (close) {
        if (! --depth) {
          name = get(ctx, name);
          if (/^f/.test(typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
            output += name.call(ctx, childCode, function (template) {
              return render(template, ctx);
            });
          } else {
            output += render(childCode, name, ctx, inverted);
          }
          childCode = "";
        }
      } else {
        ++depth;
      }
      log('mustache.output.' + depth, { output: output });
    });
  }
  log('mustache.output', { output: output });
  return output;
}

function booleanify(value) {
  var lower = value.toLowerCase();
  if (lower === 'false' || lower === '0') {
    return false;
  }
  return new Boolean(value);
}

/***/ }),

/***/ "/tool/project/client/src/core/vendor/index.js":
/***/ (function(module, exports) {

// Note vendor js loaded with System in components directly


/***/ }),

/***/ "external \"jQuery\"":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ "multi /tool/project/client/src/core/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--11-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/index.js");


/***/ })

},["multi /tool/project/client/src/core/index.js"]);


// WEBPACK FOOTER //
// scripts/core--4836ac4db9ac3e819aaa.js